<template>
    <div></div>
</template>

<script>
export default {
    name: 'End'
}
</script>

<style scoped>

</style>
